// 降落航线
export default {
    landingRoute: '降落航线',
    HDP: '高度差保护',
    generate: '生成',
    read: '读取',
    clear: '清除',
}